/* ═══════════════════════════════════════════════════════════════════════════
   TRANG KHẢO SÁT — phần chạy. Chiến dịch 107.

   Phần nhìn thấy dựng bằng Liquid: khung trang ở `sections/pheu-107-khao-sat.liquid`, từng
   câu hỏi ở `snippets/pheu-107-cau-hoi.liquid`. Việc đọc và gom câu trả lời nằm ở
   `MS107.gomCauHoi()` — dùng chung với hộp góp ý trong trang luận giải.

   File này chỉ còn lo phần riêng của trang: gửi, rồi dẫn sang trang quà kèm mã phiên.
   Không tự gọi mạng — nối backend thì sửa `assets/pheu-107-gui.js`.
   🗓️ Xoá cùng cả bộ `pheu-107-*` khi chiến dịch đóng.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var goc = document.querySelector('[data-ks7]');
  if (!goc || !window.MS107) return;

  var form    = goc.querySelector('[data-ks7-form]');
  var nut     = goc.querySelector('[data-ks7-gui]');
  var oXong   = goc.querySelector('[data-ks7-xong]');
  var nutTiep = goc.querySelector('[data-ks7-tiep]');
  var loiChung= goc.querySelector('[data-ks7-loi-chung]');
  var nutChu  = nut && nut.querySelector('span');
  if (!form) return;

  var CHU = {
    thieu:   'This one is needed.',
    xemLai:  'A couple of answers are still missing.',
    khongGui:'We could not save that just now. Reply straight to our email and we will read it there.'
  };

  MS107.noiCauHoi(form);

  /* ── Đích sang trang quà ─────────────────────────────────────────────────────
     Chỉ nhận đường dẫn nội bộ — ô này người dựng trang gõ tay, gõ nhầm địa chỉ ngoài thì
     đây thành cửa đẩy khách sang site lạ.

     Mã phiên đi bằng MẢNH NEO, không bằng tham số: mảnh neo không lên máy chủ, không lọt
     vào Referer, không nằm trong nhật ký truy cập. Mã phiên là chìa đọc bản riêng của từng
     người nên nó phải ở chỗ ít dấu vết nhất. */
  /* ── Đường đi sau khi nộp ────────────────────────────────────────────────────
     Khai mã biến thể thì khách đi thẳng vào thanh toán $0,50; bỏ trống thì đi thẳng sang
     trang quà. Giữ cả hai đường để bật/tắt bước thu tiền bằng một ô cài đặt, không phải
     sửa code giữa chiến dịch.

     Kiểm định dạng trước khi dùng: ô này người dựng trang gõ tay. Gõ nhầm thành chữ thì
     liên kết giỏ trả 404 và khách đứng trước một nút chết — thà rơi về đường cũ. */
  function maBienThe() {
    var v = (goc.getAttribute('data-ma-bien-the') || '').trim();
    return /^[0-9]{6,}$/.test(v) ? v : '';
  }

  /* ── Đường vào thanh toán: LIÊN KẾT GIỎ THẲNG, không đụng giỏ hiện có ────────
     `/cart/<biến thể>:1` dựng thẳng một giỏ chỉ gồm đúng món đó rồi vào checkout. Nó THAY
     sạch giỏ cũ chứ không cộng vào — đo 17/09/2026: giỏ đang 4 món / $30,50 (có cả hộp
     $29,99), mở liên kết này xong còn đúng 1 món / $0,50.

     Vì sao bỏ lối `/cart/add.js`: lối đó cộng dồn, nên nộp khảo sát hai lần là checkout hiện
     $1,00 trong khi cả trang hứa 50¢ — đã sập đúng như vậy hôm nay. Và nếu khách sẵn có món
     khác trong giỏ thì tổng tiền còn lệch xa hơn nữa. Liên kết thẳng thì con số ở checkout
     luôn khớp con số in trên trang, không phụ thuộc vào thứ gì có sẵn trong giỏ.

     Thêm: nhanh hơn. Lối cũ tốn hai lượt gọi giỏ (đo được 1.322ms) trước khi chuyển trang;
     lối này không gọi mạng lần nào, đi thẳng.

     ⚠️ ĐÁNH ĐỔI, phải biết: đơn KHÔNG còn mang `quiz_session`. Liên kết giỏ chỉ chở được
     thuộc tính qua QUERY, mà mã phiên là chìa đọc bản riêng của khách — nhét vào query là
     giao nó cho nhật ký máy chủ và mọi pixel, đúng thứ cả thiết kế này né. Nay phía máy chủ
     nhận diện bằng ĐỊA CHỈ THƯ, và đơn nào cũng mang sẵn địa chỉ khách gõ ở checkout, nên
     mối nối đơn ↔ phiên không còn phải đi nhờ URL nữa. */
  function dichThanhToan() {
    var bt = maBienThe();
    /* `?attributes[pheu107]=1` — cờ đánh dấu đơn thuộc chiến dịch này. Liên kết giỏ chở được
       thuộc tính CẤP ĐƠN qua query, và cờ này KHÔNG phải bí mật: nó chỉ là một nhãn phân
       loại, nằm trong log hay pixel cũng không mở được gì. Khác hẳn mã phiên — thứ tuyệt đối
       không được đặt vào query.

       Ai đọc cờ này: khối trên trang cảm ơn của Shopify
       (`minespirit-qua-tang/extensions/doc-ban-luan-giai`). Nhờ nó, khối đó phân biệt được
       đơn chiến dịch với đơn của luồng cũ, nên nhánh cũ giữ nguyên hành vi. Bỏ cờ đi thì
       khách trả tiền xong đứng trước một trang cảm ơn trống, không có đường đi tiếp. */
    if (!bt) return '';

    /* `_ms_cid`/`_ms_sid` — khách + phiên của tracker first-party, để `order_paid` (webhook)
       nối đơn với khách. `snippets/brand-ms-gan-khach.liquid` chỉ gắn vào giỏ đang CÓ HÀNG lúc
       tải trang; khách vào trang này chưa có giỏ thì permalink là chỗ duy nhất mang được chúng.
       Hàm `window.__msThuocKhach` của snippet chỉ trả khoá có cookie hợp lệ, và chỉ khi consent
       cho phép. Mã phiên quiz ở trên thì vẫn tuyệt đối không được vào query.
       ⚠️ ĐÁNH ĐỔI, khác cờ `pheu107` ngay trên: `_ms_cid` là mã riêng của TỪNG trình duyệt và
       sống lâu, không phải nhãn chung. Đo 29/09/2026 trên theme nháp: query KHÔNG bị bỏ khi
       Shopify chuyển sang checkout — URL cuối vẫn mang `attributes[_ms_cid]=…`. Pixel nào đọc
       `location.href` ở checkout (GA4/Meta, theo cổng consent riêng của chúng) nhận được một
       khoá để nối hồ sơ của chúng với `visitor_id` của tracker; `landing_site` của đơn có thể
       lưu nó (chưa đo). Đường này được chọn có chủ ý. Muốn bỏ thì POST `/cart/update.js` trước
       rồi mở permalink không kèm — đo cùng ngày: thuộc tính đã gắn sống sót qua permalink (cùng
       token giỏ; món hàng bị thay), đổi lại thêm một lượt gọi mạng trước khi rời trang. */
    var duoi = '';
    try {
      var khach = (typeof window.__msThuocKhach === 'function' && window.__msThuocKhach()) || {};
      if (khach._ms_cid) duoi += '&attributes[_ms_cid]=' + encodeURIComponent(khach._ms_cid);
      if (khach._ms_sid) duoi += '&attributes[_ms_sid]=' + encodeURIComponent(khach._ms_sid);
      if (khach._ms_c) duoi += '&attributes[_ms_c]=' + encodeURIComponent(khach._ms_c);
    } catch (e) {}
    return '/cart/' + bt + ':1?attributes[pheu107]=1' + duoi;
  }

  function dichXong() {
    var d = (goc.getAttribute('data-dich-xong') || '').trim();
    if (d.charAt(0) !== '/' || d.charAt(1) === '/') return '';
    var ma = MS107.phien();
    return d + (ma ? '#s=' + encodeURIComponent(ma) : '');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var gom = MS107.gomCauHoi(form);
    if (gom.thieu.length) {
      MS107.baoThieu(gom.thieu, CHU.thieu);
      loiChung.textContent = CHU.xemLai;
      loiChung.removeAttribute('hidden');
      return;
    }

    loiChung.setAttribute('hidden', '');
    nut.disabled = true;
    nut.setAttribute('aria-busy', 'true');

    var bt = maBienThe();

    /* Đổi chữ trên nút khi đang chạy. Bắt buộc, không phải trang trí: repo đã trả giá vì một
       nút chờ 4 giây mà giữ nguyên chữ cũ và nguyên độ đậm — khách tưởng bấm hụt nên bấm lại.
       `.ks7__nut[disabled]` lo phần mờ đi, chữ này lo phần nói ra đang chờ cái gì. */
    var chuCu = nutChu ? nutChu.textContent : '';
    if (bt && nutChu) nutChu.textContent = goc.getAttribute('data-chu-dang-gui') || chuCu;

    var loiHua = MS107.gui('survey_done', { tra_loi: gom.tra_loi });
    var dich = dichXong();

    /* ── Không có bước thu tiền: giữ nguyên lối cũ, hiện lời cảm ơn rồi mới chuyển. ───── */
    if (!bt) {
      loiHua['catch'](function () { return false; }).then(function (xong) {
        nut.disabled = false;
        nut.removeAttribute('aria-busy');
        if (!xong) {
          loiChung.textContent = CHU.khongGui;
          loiChung.removeAttribute('hidden');
        }
        form.setAttribute('hidden', '');
        oXong.removeAttribute('hidden');
        if (!dich) { nutTiep.setAttribute('hidden', ''); return; }
        nutTiep.setAttribute('href', dich);
        try { nutTiep.focus(); } catch (e2) {}
        setTimeout(function () {
          if (!oXong.hasAttribute('hidden')) window.location.assign(dich);
        }, 1800);
      });
      return;
    }

    /* ── Có bước thu tiền: ĐI THẲNG, không dừng ở màn cảm ơn ─────────────────────────────
       Vẫn phải đợi lượt gửi câu trả lời rời máy trước khi rời trang — trình duyệt huỷ mọi
       request dở dang khi điều hướng, mà câu trả lời là thứ cả chiến dịch đi xin. Nhưng đợi
       có TRẦN 2 giây: mạng kém không được phép giữ khách đứng đó. Mất một lượt ghi còn hơn
       mất một khách.

       Bỏ gói vào giỏ chạy SONG SONG với lượt gửi, không xếp hàng sau nó — hai việc không phụ
       thuộc nhau, nối tiếp là cộng dồn thời gian chờ vô ích. */
    /* Vẫn đợi lượt gửi câu trả lời rời máy trước khi rời trang — trình duyệt huỷ mọi
       request dở dang khi điều hướng. Nhưng có TRẦN 2 giây: mạng kém không được phép giữ
       khách đứng đó. Mất một lượt ghi còn hơn mất một khách. */
    var traSoLuot = new Promise(function (ok) { setTimeout(ok, 2000); });
    Promise.race([loiHua['catch'](function () { return false; }), traSoLuot])
      .then(function () {
        var di = dichThanhToan() || dich;
        window.location.assign(typeof window.__msGiuUtm === 'function' ? window.__msGiuUtm(di) : di);
      });
  });
})();
